export const ProfileGeneralForm = {
  red: {
    color: 'var(--error-500)',
    '&:hover': {
      color: 'var(--error-400)',
    },
  },

  formTitle: {
    marginBottom: '16px',
  },

  formContainer: {
    display: 'flex',
    gap: '24px',
	width: '100%',

    '@media (max-width: 640px)': {
      flexDirection: 'column',
      gap: '0px',
    },
  },

  fieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '50% !important',

    '@media (max-width: 640px)': {
      width: '100% !important',
    },
  },

  field: {
    marginBottom: '8px',

    '@media (max-width: 640px)': {
      width: '100% !important',
    },
  },

  widget: {
    padding: '16px',
    border: '1px solid var(--neutral-100)',
    borderRadius: '8px',
    background: 'var(--neutral-50)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
  },

  widgetTitle: {
    fontSize: '16px',
    color: 'var(--neutral-900)',
  },
};
